import { Component, OnInit } from '@angular/core';
import { OrderService } from "../../../services/order.service";
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { TiktokService } from '../../../shared/services/tiktok.service';
import { Package } from '../../../models/package';
import { PackageDetailsService } from '../../../shared/services/package-details.service';

@Component({
  selector: 'app-select-package-old',
  templateUrl: './select-package.component.html',
  styleUrls: ['./select-package.component.scss']
})
export class SelectPackageComponent implements OnInit {

  title = "Buy TikTok Likes";
  sub_title1 = "Do you want to jumpstart your TikTok career? We’ll provide all you need to reach the top and earn your crown!";//"If you are looking for an opportunity to buy likes for your TikTok account, then you came to the right place. Only from us, you can buy Tiktok likes in any quantity for your musical populaity.";
  sub_title2 = "Would you like to blast your TikTok account with high quality Likes, then you reached the right place. Get instant Tiktok likes at any desired quantity."//"Do you want to jumpstart your TikTok career? We’ll provide all you need to reach the top and earn your crown!";
  isMobile: boolean;
  packages: Package[] = [];
  
  constructor(private _orderSer: OrderService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _packSer: PackageDetailsService,
    private _ser: TiktokService) {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
    this._orderSer.order = {}
    this.packages = this._ser.getPackages(2)
  }

  onPackageSelected(pack: Package) {
    this._packSer.package = pack;
    this._orderSer.package_id = pack.id;
    this.router.navigate(['/buy-likes/order']);
  }

  // setPackageId(packageId: number) {
  //   this._packSer.package = pack;
  //   this._orderSer.package_id = packageId;
  //   this.router.navigate(['/buy-likes/order']);
  // }

}
